export default __webpack_public_path__ + "static/media/loading-animation-whitefd.d0ebd06d.gif";